export function initialize(apiKey, rating) {
    this.baseUrl = 'https://api.klipy.com/v2';
    this.defaultLimit = 10;

    this.apiKey = apiKey;
    this.rating = rating;
    this.clientKey = 'aasn-community';
}

export async function getTrendingTerms() {
    var terms = ['astrology', 'tarot', 'dreams', 'ritual', 'moon', 'energy', 'love', 'magic'];
    var url = `${this.baseUrl}/categories?key=${this.apiKey}&client_key=${this.clientKey}&type=trending`;

    await fetch(url)
        .then((response) => response.json())
        .then((content) => {
            if (content.tags === undefined && content.results === undefined) {
                return;
            }

            terms = (content.tags || content.results)
                .map((term) => term.searchterm || term.name || term)
                .filter(Boolean);
        })
        .catch(() => {});

    return terms;
}

export async function getTrendingGIFs(pos, limit) {
    var obj;
    var url = `${this.baseUrl}/featured?key=${this.apiKey}&client_key=${this.clientKey}&contentfilter=${
        this.rating
    }&media_filter=gif,tinygif&limit=${
        limit || this.defaultLimit
    }${pos ? `&pos=${pos}` : ''}`;

    await fetch(url)
        .then((response) => response.json())
        .then((content) => {
            if (content.results === undefined) {
                console.error('Sorry, there was something wrong with the Tenor API Key.');
                return;
            }

            obj = {
                gifs: content.results,
                next: content.next
            };
        });

    return obj;
}

export async function getGIFs(query, pos, limit) {
    var obj;
    var url = `${this.baseUrl}/search?key=${this.apiKey}&client_key=${this.clientKey}&q=${query}&contentfilter=${
        this.rating
    }&media_filter=gif,tinygif&limit=${limit || this.defaultLimit}${pos ? `&pos=${pos}` : ''}`;

    await fetch(url)
        .then((response) => response.json())
        .then((content) => {
            if (content.results === undefined) {
                console.error('Sorry, there was something wrong with the Tenor API Key.');
                return;
            }

            obj = {
                gifs: content.results,
                next: content.next
            };
        });

    return obj;
}

export async function getGIFsByIDs(ids) {
    var gifs;
    var url = `${this.baseUrl}/posts?key=${this.apiKey}&client_key=${this.clientKey}&ids=${ids}&media_filter=gif,tinygif`;

    await fetch(url)
        .then((response) => response.json())
        .then((content) => {
            gifs = content.results;
        });

    return gifs;
}

export function extractGIF(gif) {
    var formats = gif.media_formats || {};

    return {
        id: gif.id,
        title: gif.content_description || gif.title || 'GIF',
        url: (formats.gif || formats.tinygif || gif.media[0].gif).url
    };
}

export function getLimit() {
    return this.defaultLimit;
}
